<aside
  #mainSidebar
  class="main-sidebar sidebar-light-primary elevation-4 cus-text"
  style="overflow: visible !important; position: fixed;"
>
  <!-- Brand Logo -->
  <a [routerLink]="['/']" class="brand-link">
    <img src="assets/img/unilogo.png"  class="brand-image" />
    <div class="brand-text font-weight-light">UniLeader</div>
  </a>
  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column"  data-widget="treeview" role="menu" data-accordion="false"
      >
        <li id="menu1" class="nav-item menu-open">
          <a class="nav-link cus-bg" (click)="menu('menu1')" style="background: #418994; color: white;" >
          &nbsp;
            <p>Báo cáo tổng hợp <i class="right fa fa-angle-left"></i> </p>
          </a>
          <ul class="nav nav-treeview">
              <li class="nav-item" *ngIf="TimKiemDonGian">
                <a  [routerLink]="['/TimKiemDonGian']" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <i class="fas fa-search"></i> <p>&nbsp;Tìm kiếm đơn giản</p>
                </a>
              </li>
                    
              <li class="nav-item" *ngIf="QuaTrinhKhenThuong">
                <a  [routerLink]="['/QuaTrinhKhenThuong']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fab fa-gitter"></i> <p>&nbsp;Thống kê khen thưởng</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="QuaTrinhKyLuat">
                <a  [routerLink]="['/QuaTrinhKyLuat']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fab fa-schlix"></i> <p>&nbsp;Thống kê kỷ luật</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="QuanLyHSSV">
                <a  [routerLink]="['/HoSoHocSinhSinhVien']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-file-archive"></i> <p>&nbsp;Thống kê số lượng SV</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="QuaTrinhHocTapRenLuyen">
                <a  [routerLink]="['/HocTapRenLuyen']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-award"></i> <p>&nbsp;Thống kê điểm rèn luyện</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="SVThoiHocNgungHoc">
                <a  [routerLink]="['/ThoiHocNgungHoc']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-stop-circle"></i> <p>&nbsp;SV thôi học, ngừng học</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="TongHopThiLaiHocLai">
                <a  [routerLink]="['/TongHopThiLaiHocLai']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-redo"></i> <p>&nbsp;Tổng hợp thi lại, học lại</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="ThongKeTheoQuyetDinh">
                <a  [routerLink]="['/ThongKeTheoQD5363']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-file-word"></i> <p>&nbsp;Thống kê theo QĐ 5363</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="ThongKeXLHKNH">
                <a  [routerLink]="['/XepLoaiHocKyNamHoc']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-closed-captioning"></i> <p>&nbsp;Tổng hợp điểm</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="ThongKeXLHDHP">
                <a  [routerLink]="['/XepLoaiDiemHocPhan']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-marker"></i> <p>&nbsp;Xếp loại theo điểm học phần</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="TongHopNoHPKP">
                <a  [routerLink]="['/TongHopNoHocPhiKinhPhi']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-file-invoice-dollar"></i> <p>&nbsp;Tổng hợp nợ học phí, kinh phí</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="TongHopNoPhiLePhi">
                <a  [routerLink]="['/TongHopNoPhiLePhi']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-search-dollar"></i> <p>&nbsp;Tổng hợp nợ phí và lệ phí</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="ThongTinHPLP">
                <a  [routerLink]="['/ThongTinHocPhiLePhi']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-info"></i> <p>&nbsp;Thông tin học phí và lệ phí</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="BaoCaoTHTHC">
                <a  [routerLink]="['/BaoCaoTongHopThuChi']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fab fa-adversal"></i> <p>&nbsp;Báo cáo tổng hợp thu/chi</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="TraCuuCongViecGiangDay">
                <a  [routerLink]="['/TraCuuCongViecGiangDay']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-briefcase"></i> <p>&nbsp;Tra cứu công việc giảng dạy</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="SoLenLop">
                <a  [routerLink]="['/note-book-class']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-briefcase"></i> <p>&nbsp;Sổ lên lớp</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="TraCuuNhanXetGiangDay">
                <a  [routerLink]="['/TraCuuNhanXetGiangDay']" class="nav-link" routerLinkActive="active"  [routerLinkActiveOptions]="{ exact: true }"   >
                  <i class="fas fa-briefcase"></i> <p>&nbsp;Tra cứu nhận xét giảng dạy</p>
                </a>
              </li>
          </ul>
        </li>
      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
</aside>
